import React from "react";
import PropTypes from "prop-types";
import { Form as FormikForm, InputField, CheckboxField } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import * as Yup from "yup";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";

function Form({ data, resources, mode, ...rest }) {
    const { modules } = resources;

    const initialValues = { ...data, modules: data.modules.reduce((acc, m) => ({ ...acc, [m.id]: true }), {}) };

    const validationSchema = Yup.object({
        code: Yup.string().required("Required field"),
        name: Yup.string().required("Required field"),
    });

    return (
        <FormikForm initialValues={initialValues} validationSchema={validationSchema} {...rest}>
            <div className="layout">
                <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                        <FormControl component="fieldset">
                            <FormGroup row>
                                <InputField
                                    disabled={mode === "update"}
                                    fieldName="code"
                                    label="Code *"
                                    autoFocus
                                    uppercase
                                    fullWidth={false}
                                />
                                <InputField fieldName="name" label="Name *" />
                                <InputField fieldName="description" label="Description" />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">Applies to modules:</FormLabel>
                            <FormGroup>
                                {modules.map(({ id, name }, index) => (
                                    <CheckboxField key={index} fieldName={`modules.${id}`} label={name} />
                                ))}
                            </FormGroup>
                        </FormControl>
                    </Grid>
                </Grid>
            </div>
        </FormikForm>
    );
}

Form.propTypes = {
    data: PropTypes.shape({
        code: PropTypes.string,
        name: PropTypes.string,
        description: PropTypes.string,
        modules: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    resources: PropTypes.shape({
        modules: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                code: PropTypes.string,
                name: PropTypes.string,
                description: PropTypes.string,
            })
        ),
    }),
    mode: PropTypes.oneOf(["add", "update"]).isRequired,
};

Form.defaultProps = {
    data: {
        code: "",
        name: "",
        description: "",
        modules: [],
    },
    resources: {
        modules: [],
    },
};

export default Form;
